import { JobDuration } from "@api/shared-runtime/enums";

export const jobDurationOptions = [
  { value: null, label: "Any duration" },
  { value: JobDuration.FullTime, label: "Full-time" },
  { value: JobDuration.PartTime, label: "Part-time" },
  { value: JobDuration.PerDiemPRN, label: "Per-diem / PRN" },
  { value: JobDuration.Contract, label: "Contract" },
  { value: JobDuration.Consulting, label: "Consulting" },
  { value: JobDuration.Locums, label: "Locums" },
];

export const jobDurationLabels = {
  [JobDuration.FullTime]: "Full-time",
  [JobDuration.PartTime]: "Part-time",
  [JobDuration.PerDiemPRN]: "Per-diem / PRN",
  [JobDuration.Contract]: "Contract",
  [JobDuration.Consulting]: "Consulting",
  [JobDuration.Locums]: "Locums",
};

export function getJobDurationLabel(durationId: number): string | undefined {
  return jobDurationLabels[durationId as keyof typeof jobDurationLabels];
}
